import axios from 'axios';

import BaseCrud from './baseCrud';

const crud = new BaseCrud('event');

export const state = () => ({
    ...crud.state,
    CANCELLED: 'cancelled'
});

export const getters = {
    ...crud.getters,
    CANCELLED: state => state.CANCELLED
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    cancel(vuexContext, id) {
        return axios.put(`/admin/events/${id}/cancel`);
    },

    getUsers(
        ctx,
        {
            id,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'Event2User.createdAt',
            descending = true,
            filters = null,
            status = null
        }
    ) {
        const params = {
            status,
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/events/${id}/users`, {
            params
        });
    },

    acceptTicket(ctx, { eventId, code }) {
        return axios.$post(`/admin/events/${eventId}/tickets/${code}/accept`);
    },

    getTicket(ctx, { eventId, code }) {
        return axios.$get(`/admin/events/${eventId}/tickets/${code}`);
    }
};
